module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-5.f2d2a4af.jpg";